import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n  border: 1px solid ",
        ';\n  background: transparent;\n  padding: 10px 14px 12px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  font-size: 14px;\n  font-family: "DM Sans", sans-serif;\n  color: ',
        ";\n  &:disabled {\n    background: transparent;\n    font-weight: 400;\n    border: 1px solid ",
        ";\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Button from "../Button/Button";
import { variants } from "../Button/types";
var InactiveButton = styled(Button).withConfig({
    componentId: "sc-954e2b9e-0"
})(_templateObject(), function(param) {
    var theme = param.theme, isDatepicker = param.isDatepicker;
    return !isDatepicker ? "transparent" : theme.colors.backgroundAlt;
}, function(param) {
    var theme = param.theme, variant = param.variant;
    return variant === variants.PRIMARY ? theme.colors.primary : theme.colors.textSubtle;
});
var StyledButton = styled(Button).withConfig({
    componentId: "sc-954e2b9e-1"
})(_templateObject1(), function(param) {
    var side = param.side;
    return side === "center" || side === "right" ? "0" : "5px";
}, function(param) {
    var side = param.side;
    return side === "center" || side === "right" ? "0" : "5px";
}, function(param) {
    var side = param.side;
    return side === "center" || side === "left" ? "0" : "5px";
}, function(param) {
    var side = param.side;
    return side === "center" || side === "left" ? "0" : "5px";
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.alienPurple : theme.colors.inputBorder;
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.text : theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
var ButtonMenuItem = function(_param) {
    var _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, _variant = _param.variant, variant = _variant === void 0 ? variants.PRIMARY_C : _variant, as = _param.as, isDatepicker = _param.isDatepicker, props = _object_without_properties(_param, [
        "isActive",
        "variant",
        "as",
        "isDatepicker"
    ]);
    return /*#__PURE__*/ _jsx(StyledButton, _object_spread({
        isActive: isActive,
        as: as,
        variant: variant
    }, props));
};
export default ButtonMenuItem;
